module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/imgDesktop-d0f33271c06937aa1187f09500e5c963.png";